import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get purchaseOrderBranch
export const getPurchaseOrderBranch = createAsyncThunk(
  "purchaseOrderBranch/getPurchaseOrderBranch",
  async (params, { rejectWithValue }) => {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    try {
      const { data } = await API.getPurchaseOrderBranch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get all purchaseOrderBranch
export const getAllPurchaseOrderBranch = createAsyncThunk(
  "purchaseOrderBranch/getAllPurchaseOrderBranch",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllPurchaseOrderBranch();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk("purchaseOrderBranch/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("purchaseOrderBranch/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "purchaseOrderBranch/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPagePurchaseOrderBranch({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get purchaseOrderBranch by additional charge
export const getPurchaseOrderBranchAdditionalChargeList = createAsyncThunk(
  "purchaseOrderBranch/getPurchaseOrderBranchAdditionalChargeList",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getPurchaseOrderBranchAdditionalChargeList();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
export const getPurchaseOrderBranchChargeStatus = createAsyncThunk(
  "purchaseOrderBranch/getPurchaseOrderBranchChargeStatus ",
  async (type, { rejectWithValue }) => {
    try {
      const { data } = await API.getPurchaseOrderBranchChargeStatus(type);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get item by id
export const getPurchaseOrderBranchById = createAsyncThunk(
  "purchaseOrderBranch/getPurchaseOrderBranchById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getPurchaseOrderBranchById(id);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
// get item by id
export const getSaleOrderDetail = createAsyncThunk(
  "purchaseOrderBranch/getSaleOrderDetail",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getSaleOrderDetail(id);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create purchaseOrderBranch
export const createPurchaseOrderBranch = createAsyncThunk(
  "purchaseOrderBranch/createPurchaseOrderBranch",
  async (createData, { rejectWithValue }) => {
    const {
      purchaseOrderBranchDetails,
      purchaseOrderBranchMainAdditionalChargeCost,
      partyAccount,
      voucherDate,
      voucherDateBs,
      narration,
      branch,
      purchaseOrderBranchMainPartyDetails,
      purchaseOrderBranchMainVehicleDetail,
      discountAmount,
      grandTotal,
      vatAmount,
    } = createData;
    try {
      const body = JSON.stringify({
        purchaseOrderBranchDetails,
        purchaseOrderBranchMainAdditionalChargeCost,
        partyAccount,
        voucherDate,
        voucherDateBs,
        narration,
        branch,
        purchaseOrderBranchMainPartyDetails,
        purchaseOrderBranchMainVehicleDetail,
        discountAmount,
        grandTotal,
        vatAmount,
      });
      const { data } = await API.createPurchaseOrderBranch(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const updatePurchaseOrderBranch = createAsyncThunk(
  "purchaseOrderBranch/updatePurchaseOrderBranch",
  async (data, { rejectWithValue }) => {
    const { id, values } = data;
    const {
      salesOrder,
      indentNo,
      isFromHo,
      requiredDateAd,
      voucherDate,
      voucherDateBs,
      branch,
      status,
      documentsAttach,
      // refVoucher,
      purchaseOrderBranchDetails,
      purchaseOrderBranchMainPartyDetails,
      purchaseOrderBranchMainVehicleDetail,
    } = values;
    try {
      const body = JSON.stringify({
        salesOrder,
        indentNo,
        isFromHo,
        requiredDateAd,
        branch,
        status,
        voucherDate,
        voucherDateBs,
        // refVoucher,
        purchaseOrderBranchDetails,
        purchaseOrderBranchMainPartyDetails,
        purchaseOrderBranchMainVehicleDetail,
      });
      const { data } = await API.updatePurchaseOrderBranch(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk(
  "purchaseOrderBranch/handleSearch",
  async ({ rowsPerPage, search, sortOrder, pageNo }, { rejectWithValue }) => {
    try {
      const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
